import type {FC} from 'react';
import {ErrorMessage, GisContext, TrackScreenshotMap} from 'talptech-gis-components';
import parseTrackScreenshotQueryParameters from '../domain/useCases/parseTrackScreenshotQueryParameters';
import 'talptech-gis-components/styles.css';

const GIS_API_BASE_URL = process.env.GIS_API_BASE_URL || '';
const CRM_API_BASE_URL = process.env.CRM_API_BASE_URL || '';

const TrackScreenshotPage: FC = () => {
  try {
    const {trackUuid, jwtToken, lang} = parseTrackScreenshotQueryParameters(window.location.href);

    return (
      <GisContext
        gisApiBaseUrl={GIS_API_BASE_URL}
        crmApiBaseUrl={CRM_API_BASE_URL}
        accessToken={jwtToken}
        language={lang}
      >
        <TrackScreenshotMap trackUuid={trackUuid} />
      </GisContext>
    );
  } catch (e) {
    const message = e instanceof Error ? e.message : 'Unknown cause';
    return <ErrorMessage>Error: {message}</ErrorMessage>;
  }
};

export default TrackScreenshotPage;
